import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

import { ShadedBackgroundColorProp } from '~app/components/EndpageImage';

type StyleProps = {
  shadedBackgroundColor: ShadedBackgroundColorProp | undefined;
};

const useStyles = createUseStyles(
  ({ brandColors: { background }, breakpoints, type: { fontSize, fontWeight } }: CmsWrenchTheme) => {
    const mediaQueryMinScreenLG = `@media (min-width: ${breakpoints.lg}px)`;
    const mediaQueryMinScreenMD = `@media (min-width: ${breakpoints.md}px)`;

    return {
      container: ({ shadedBackgroundColor }: StyleProps) => ({
        background: shadedBackgroundColor ? background[shadedBackgroundColor] : undefined,
      }),
      headingText: {
        fontWeight: fontWeight.medium,
        [mediaQueryMinScreenLG]: {
          fontSize: fontSize.pageTitle,
        },
      },
      logo: {
        height: 22,
        [mediaQueryMinScreenMD]: {
          height: 29,
        },
        width: '100%',
      },
      subheadingText: {
        [mediaQueryMinScreenMD]: {
          fontSize: (fontSize.body as number) * 1.125,
        },
      },
    };
  }
);

export default useStyles;
